export default __webpack_public_path__ + "static/media/user-list-off.e7038cfe.svg";